// 'use client';

// import { useTranslations, useLocale } from 'next-intl';
// import { usePathname, useRouter } from 'next/navigation';
// import { locales } from '@/lib/i18n';

// export default function LanguageSwitcher() {
//   const t = useTranslations('common');
//   const locale = useLocale();
//   const pathname = usePathname();
//   const router = useRouter();

//   const switchLanguage = (newLocale: string) => {
//     // Remove current locale from pathname
//     const pathWithoutLocale = pathname.replace(`/${locale}`, '') || '/';
//     const newPath = `/${newLocale}${pathWithoutLocale}`;
//     router.push(newPath);
//   };

//   return (
//     <button
//       onClick={() => switchLanguage(locale === 'en' ? 'ga' : 'en')}
//               className="px-4 py-2 bg-[#f7cf1f] text-[#632563] font-bold rounded-md transition-all duration-200 hover:bg-[#632563] hover:text-[#f7cf1f] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#f7cf1f] focus:ring-offset-2 focus:ring-offset-transparent"
//       aria-label={`Switch to ${locale === 'en' ? 'Irish' : 'English'}`}
//     >
//       {locale === 'en' ? 'GAEILGE' : 'ENGLISH'}
//     </button>
//   );
// }




// 'use client';

// import {useLocale} from 'next-intl';
// import {usePathname, useRouter} from 'next-intl/navigation';

// export default function LanguageSwitcher() {
//   const locale = useLocale();
//   const router = useRouter();
//   const pathname = usePathname() || '/';

//   const other = locale === 'en' ? 'ga' : 'en';

//   const handleSwitch = () => {
//     // Remove only a LEADING /en or /ga
//     const bare = pathname.replace(/^\/(en|ga)(?=\/|$)/, '') || '/';
//     // Use next-intl's router so the locale cookie & middleware stay in sync
//     router.replace(bare, {locale: other});
//   };

//   return (
//     <button
//       onClick={handleSwitch}
//       className="px-4 py-2 bg-[#f7cf1f] text-[#632563] font-bold rounded-md transition-all duration-200 hover:bg-[#632563] hover:text-[#f7cf1f] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#f7cf1f] focus:ring-offset-2"
//       aria-label={`Switch to ${other === 'ga' ? 'Gaeilge' : 'English'}`}
//     >
//       {other === 'ga' ? 'GAEILGE' : 'ENGLISH'}
//     </button>
//   );
// }



'use client';

import {useLocale} from 'next-intl';
import {usePathname, useRouter} from 'next/navigation';

export default function LanguageSwitcher() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname() || '/';

  const other = locale === 'en' ? 'ga' : 'en';

  const handleSwitch = () => {
    const bare = pathname.replace(/^\/(en|ga)(?=\/|$)/, '') || '/';
    const target = `/${other}${bare}`;
    router.push(target);
  };

  return (
    <button
      onClick={handleSwitch}
      className="px-4 py-2 bg-[#f7cf1f] text-[#632563] font-bold rounded-md transition-all duration-200 hover:bg-[#632563] hover:text-[#f7cf1f] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#f7cf1f] focus:ring-offset-2"
      aria-label={`Switch to ${other === 'ga' ? 'Gaeilge' : 'English'}`}
    >
      {other === 'ga' ? 'Gaeilge' : 'English'}
    </button>
  );
}